<div #container>

  <span #anchor><ngx-emoji [emoji]="selectedEmoji!" [size]="20"></ngx-emoji>
    <button class="btn btn-link button-position" (click)="onClick()">
      {{ show ? "Close..." : "Like..." }}
    </button>
  </span>
  @if (show) {
  <kendo-popup [anchor]="anchor" [popupAlign]="popupAlign">
    <div class="content">
      <emoji-mart class="picker" color="var(--str-chat__primary-color)" title="Pick your emoji…" emoji="point_up"
        (emojiSelect)="emojiSelected($event)" [isNative]="true"></emoji-mart>
    </div>
  </kendo-popup>
  }
</div>
